// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__cTlmr","footer":"ModalUpdate_footer__2MXGS"};